$(document).ready(function () {
    // add email link if it is missing
    $('a:not([href])').each(function(){
      if($(this).text().includes('@')){
        $(this).attr('href', 'mailto:' + $(this).text());
      }
    });

});

